<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.logradouro"
        :request-params="requestParams"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{ item }">
            <template v-if="selectionMode">
                <rkm-button
                    @click="$emit('select', item)"
                    color="primary"
                    small
                    title="Selecionar"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="check" />
                </rkm-button>
            </template>

            <template v-else>
                <rkm-button
                    v-if="authorize('cadastro-logradouro-update')"
                    :to="{name: 'cadastro-logradouro-edit', params: {id: item.logradouro_id}}"
                    color="primary"
                    small
                    title="Editar"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    v-if="authorize('cadastro-logradouro-destroy')"
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'estado_uf',
                    label: 'UF',
                    name: 'cadastro_estado.uf',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'municipio_nome',
                    label: 'Município',
                    name: 'cadastro_municipio.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'bairro_nome',
                    label: 'Bairro',
                    name: 'cadastro_bairro.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'logradouro_tipo_nome',
                    label: 'Tipo',
                    name: 'cadastro_logradouro_tipo.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'logradouro_nome',
                    label: 'Nome',
                    name: 'cadastro_logradouro.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'logradouro_cep',
                    label: 'CEP',
                    name: 'cadastro_logradouro.cep',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ]
        },
        requestParams() {
            let params = {}

            if (this.classificacao_id) {
                params.classificacao_id = this.classificacao_id
            }

            return params
        },
    },
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.logradouro.destroy(item.logradouro_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir o logradouro ${item.logradouro_nome}?`, destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
    props: {
        classificacao_id: {type: Number},
        selectionMode: {type: Boolean},
    },
}
</script>